module.exports = __webpack_public_path__ + "base_circular_vqt.png?e612f39e1f18fa88ae3e01095fc33818";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base_circular_vqt.png
// module id = 8
// module chunks = 0